import React, { Fragment } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'
import './DashboardChartsV2.scss'
import iconChevronDown from 'Assets/Icons/AdminDashboard/mn9vwcis-68oqs55.png' // Reusing existing icon or placeholder

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
)

const DashboardChartsV2: React.FC = () => {
  const labels = ['W1', 'W2', 'W3', 'W4', 'W5', 'W6', 'W7', 'W8']

  const barData = {
    labels,
    datasets: [
      {
        data: [62, 80, 72, 55, 62, 72, 82, 42],
        backgroundColor: '#E873A8',
        borderRadius: 4,
        barThickness: 48,
      },
    ],
  }

  const barOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 100,
        ticks: {
          callback: (value: any) => `₦${value}M`,
          stepSize: 10,
          color: '#666666',
          font: {
            size: 11,
            family: 'Inter',
          },
        },
        grid: {
          color: '#F2F4F7',
          drawBorder: false,
        },
      },
      x: {
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          color: '#666666',
          font: {
            size: 11,
            family: 'Inter',
          },
        },
      },
    },
  }

  return (
    <div className='chartCard'>
      <div className='chartHeader'>
        <div className=''>
          <h4 className='chartTitle'>User Registrations</h4>
          <div className='chart-tagline'>All products — last 8 weeks</div>
        </div>

        <div className='chartFilter'>
          <select name='timeframe' id='timeframe' className='border-0'>
            <option value='30'>All Product</option>
            <option value='7'>BoostXpress</option>
            <option value='7'>TDLA</option>
            <option value='7'>TGPlus</option>
          </select>
          <img src={iconChevronDown} alt='Filter' className='filterIcon' />
        </div>
      </div>
      <div className='chartContent'>
        <Bar data={barData} options={barOptions} />
      </div>
    </div>
  )
}

export default DashboardChartsV2
